import React, { useEffect, useRef } from 'react';
import { Chart } from 'chart.js/auto';
import _ from 'lodash';

const SalesTrendChart = ({ salesData }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (salesData?.length > 0) {
      const groupedData = _.groupBy(salesData, 'formatted_created_at');
      const dates = Object.keys(groupedData);
      const amounts = dates.map((date) =>
        _.sumBy(groupedData[date], 'amount')
      );

      const ctx = chartRef.current.getContext('2d');

      // Destruir el gráfico anterior si existe
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }

      chartInstance.current = new Chart(ctx, {
        type: 'line',
        data: {
          labels: dates,
          datasets: [
            {
              label: 'Ventas por día',
              data: amounts,
              borderColor: 'rgba(75, 192, 192, 1)',
              borderWidth: 2,
              fill: false,
            },
          ],
        },
        options: {
          scales: {
            x: {
              type: 'category',
              labels: dates,
            },
            y: {
              beginAtZero: true,
            },
          },
          plugins: {
            tooltip: {
              callbacks: {
                label: (context) => {
                  const label = context.label;

                  // Agregar información adicional al tooltip
                  const salesForDate = groupedData[label];
                  const totalSales = _.sumBy(salesForDate, 'amount');
                  return `${label}: ${totalSales} ventas`;
                },
              },
            },
          },
        },
      });
    }

    // Limpiar el gráfico cuando el componente se desmonta
    return () => {
        if (chartInstance.current) {
            chartInstance.current.destroy();
        }
    };
  }, [salesData]);

  return <canvas ref={chartRef} />;
};

export default SalesTrendChart;
